export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const stats = [
    { icon: 'ri-calendar-check-line', value: '18+', label: 'лет практики' },
    { icon: 'ri-building-2-line', value: '100+', label: 'корпоративных проектов' },
    { icon: 'ri-presentation-line', value: '450+', label: 'тренингов' },
    { icon: 'ri-user-star-line', value: '4500+', label: 'участников' },
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/569728fd-c91c-4038-9029-15ec61dcf92d_compressed_salesconf.webp"
          alt="Тренинг по работе с возражениями клиентов"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-28 md:pt-20 pb-10 md:pb-16">
        <div className="grid lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-3 text-left">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-5 leading-tight">
              Тренинг по работе с возражениями клиентов для отдела продаж
            </h1>
            <p className="text-lg md:text-xl text-white/90 mb-8 leading-relaxed max-w-2xl font-medium">
              Научим сотрудников уверенно работать с любыми возражениями клиентов без давления, шаблонных фраз и постоянных скидок.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10">
              <button
                onClick={() => scrollTo('contact')}
                className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center"
              >
                Обучить команду работе с возражениями
                <i className="ri-arrow-right-line"></i>
              </button>
              <button
                onClick={() => scrollTo('contact')}
                className="bg-white/15 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-white/25 transition-all hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center border border-white/30"
              >
                Заказать консультацию
                <i className="ri-chat-1-line"></i>
              </button>
            </div>

            <button
              onClick={() => scrollTo('cases')}
              className="text-white/80 hover:text-white font-semibold inline-flex items-center gap-2 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-down-line"></i>
              Показать кейсы
            </button>
          </div>

          <div className="lg:col-span-2 hidden lg:block">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden bg-teal-600 flex-shrink-0">
                  <img
                    src="https://static.readdy.ai/image/045fa1b133efd9567759baab28602a6d/d5f5f47c7d94e3dc67c5ef073553230f.jpeg"
                    alt="Алексей Сивко"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-white font-bold text-lg">Алексей Сивко</div>
                  <div className="text-white/70 text-sm">Бизнес-тренер, эксперт по продажам</div>
                </div>
              </div>
              <div className="space-y-3">
                {stats.map((s, i) => (
                  <div key={i} className="flex items-center gap-3 text-white/90">
                    <div className="w-8 h-8 bg-teal-600/60 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${s.icon} text-sm text-white`}></i>
                    </div>
                    <span className="text-sm">
                      <strong>{s.value}</strong> {s.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}